// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.IncomingCall__container-a7d6ad {
  position: relative;
  overflow: hidden;
  width: 320px;
  min-height: 362px;
  padding: var(--indent-24px) var(--indent-16px);
  background-color: var(--addition-80);
  border-radius: var(--indent-24px);
  box-shadow: var(--box-shadow-12);
  border: none;
}

.IncomingCall__container-a7d6ad::before,
.IncomingCall__container-a7d6ad::after {
  content: "";
  position: absolute;
  filter: blur(100px);
  z-index: 0;
  pointer-events: none;
  border-radius: 50%;
}

.IncomingCall__container-a7d6ad::before {
  width: 273px;
  height: 273px;
  left: -152px;
  bottom: -117px;
  background: var(--incoming-call-glow-2);
}

.IncomingCall__container-a7d6ad::after {
  width: 285px;
  height: 285px;
  right: -92px;
  top: -126px;
  background: var(--incoming-call-glow-1);
}

.IncomingCall__content-b6d016 {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 100%;
  position: relative;
  z-index: 1;
}

.IncomingCall__group-title-acde63 {
  color: var(--addition-50);
  margin-top: var(--indent-16px);
  font: var(--font-title-9);
  letter-spacing: var(--font-spacing-title);
  white-space: nowrap;
  overflow-x: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}

.IncomingCall__calling-state-fe6b8c {
  color: var(--addition-50);
  opacity: 0.7;
  margin-top: var(--indent-8px);
  font: var(--font-body-4);
  letter-spacing: var(--font-spacing-body);
}

.IncomingCall__actions-panel-bf073e {
  display: flex;
  margin-top: var(--indent-24px);
  justify-content: space-between;
}

.IncomingCall__button-bfc8b1 {
  margin: 0 12px;
}`, "",{"version":3,"sources":["webpack://./src/main/IncomingCall/IncomingCall.styles.m.css"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,iBAAA;EACA,8CAAA;EACA,oCAAA;EACA,iCAAA;EACA,gCAAA;EACA,YAAA;AACF;;AAEA;;EAEE,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,UAAA;EACA,oBAAA;EACA,kBAAA;AACF;;AAEA;EACE,YAAA;EACA,aAAA;EACA,YAAA;EACA,cAAA;EACA,uCAAA;AACF;;AAEA;EACE,YAAA;EACA,aAAA;EACA,YAAA;EACA,WAAA;EACA,uCAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,8BAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;AACF;;AAEA;EACE,yBAAA;EACA,8BAAA;EACA,yBAAA;EACA,yCAAA;EACA,mBAAA;EACA,kBAAA;EACA,uBAAA;EACA,eAAA;AACF;;AAEA;EACE,yBAAA;EACA,YAAA;EACA,6BAAA;EACA,wBAAA;EACA,wCAAA;AACF;;AAEA;EACE,aAAA;EACA,8BAAA;EACA,8BAAA;AACF;;AAEA;EACE,cAAA;AACF","sourcesContent":[".container {\n  position: relative;\n  overflow: hidden;\n  width: 320px;\n  min-height: 362px;\n  padding: var(--indent-24px) var(--indent-16px);\n  background-color: var(--addition-80);\n  border-radius: var(--indent-24px);\n  box-shadow: var(--box-shadow-12);\n  border: none;\n}\n\n.container::before,\n.container::after {\n  content: '';\n  position: absolute;\n  filter: blur(100px);\n  z-index: 0;\n  pointer-events: none;\n  border-radius: 50%;\n}\n\n.container::before {\n  width: 273px;\n  height: 273px;\n  left: -152px;\n  bottom: -117px;\n  background: var(--incoming-call-glow-2);\n}\n\n.container::after {\n  width: 285px;\n  height: 285px;\n  right: -92px;\n  top: -126px;\n  background: var(--incoming-call-glow-1);\n}\n\n.content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  height: 100%;\n  position: relative;\n  z-index: 1;\n}\n\n.group-title {\n  color: var(--addition-50);\n  margin-top: var(--indent-16px);\n  font: var(--font-title-9);\n  letter-spacing: var(--font-spacing-title);\n  white-space: nowrap;\n  overflow-x: hidden;\n  text-overflow: ellipsis;\n  max-width: 100%;\n}\n\n.calling-state {\n  color: var(--addition-50);\n  opacity: 0.7;\n  margin-top: var(--indent-8px);\n  font: var(--font-body-4);\n  letter-spacing: var(--font-spacing-body);\n}\n\n.actions-panel {\n  display: flex;\n  margin-top: var(--indent-24px);\n  justify-content: space-between;\n}\n\n.button {\n  margin: 0 12px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `IncomingCall__container-a7d6ad`,
	"content": `IncomingCall__content-b6d016`,
	"group-title": `IncomingCall__group-title-acde63`,
	"groupTitle": `IncomingCall__group-title-acde63`,
	"calling-state": `IncomingCall__calling-state-fe6b8c`,
	"callingState": `IncomingCall__calling-state-fe6b8c`,
	"actions-panel": `IncomingCall__actions-panel-bf073e`,
	"actionsPanel": `IncomingCall__actions-panel-bf073e`,
	"button": `IncomingCall__button-bfc8b1`
};
module.exports = ___CSS_LOADER_EXPORT___;
